import { RequestHeader } from "./request-header";
import { ResendOtpRequestBody } from "./resend-otp-request-body";

export class ResendOtpRequest {
    header: RequestHeader;
    body: ResendOtpRequestBody;

}
